import { TextInput, SimpleForm, SelectInput, ImageInput } from 'react-admin'
import Grid from '@mui/material/Grid'

import GridContainer from '../../components/GridContainer'
import BookToolbar from '../../components/BookToolbar'
import CustomImageField from '../../components/CustomImageField'
import { validateRequired } from '../../utils/validate'

const TopicForm = props => {
  const DISPLAY_ON_CHOICES = [{ id: 'kid_tab', name: 'Kid Tab' }]

  const TYPES = [
    { id: 'all', name: 'All' },
    { id: 'book', name: 'Book' },
    { id: 'english_book', name: 'English book' },
    { id: 'book_summary', name: 'Book summary' },
    { id: 'ebook', name: 'Ebook' },
    { id: 'kids_story', name: 'Kids Story' },
  ]

  return (
    <SimpleForm {...props} toolbar={<BookToolbar />} redirect="list">
      <GridContainer>
        {props.editing && (
          <Grid item xs={12}>
            <TextInput source="slug" fullWidth variant="standard" disabled />
          </Grid>
        )}
        <Grid item xs={8}>
          <TextInput
            source="name"
            fullWidth
            variant="standard"
            validate={[validateRequired('Type')]}
          />
        </Grid>
        <Grid item xs={4}>
          <SelectInput
            source="type"
            choices={TYPES}
            fullWidth
            variant="standard"
            required
            validate={validateRequired('Type')}
          />
        </Grid>
        <Grid item xs={4}>
          <SelectInput
            source="displayOn"
            choices={DISPLAY_ON_CHOICES}
            fullWidth
            variant="standard"
            emptyText="None"
            allowEmpty
            InputLabelProps={{ shrink: true }}
          />
        </Grid>
        <Grid item xs={12}>
          <ImageInput
            source="iconUrl"
            label="Icon"
            accept="image/*"
            multiple={false}>
            <CustomImageField source="src" title="Icon" />
          </ImageInput>
        </Grid>
      </GridContainer>
    </SimpleForm>
  )
}

export default TopicForm
